import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import { aiContentData, AIContentDataType } from './aiContentData'
import clsx from 'clsx'
import classes from './AIContent.module.scss'

export const AIContent = () => {
  return (
    <>
      {aiContentData.map((item, idx) => (
        <AIContentSection item={item} key={idx} />
      ))}
    </>
  )
}

const AIContentSection = ({ item }: { item: AIContentDataType }) => {
  const { tag, title, visual, description } = item

  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={clsx(classes.section, !visual && classes.section__result)}
    >
      <hgroup className={classes.heading}>
        <div className={classes.tag}>
          <div className={classes.glow} />
          <Text as={'span'} size={'sm'} className={classes.number}>
            {tag}
          </Text>
        </div>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          {title}
        </Heading>
      </hgroup>

      {visual && (
        <div
          className={clsx(
            classes.visual,
            visual.hasMobile && classes.visual__narrow,
          )}
        >
          <Picture
            mobSrc1x={visual.imageMob1x.src}
            mobSrc2x={visual.imageMob2x.src}
            deskSrc1x={visual.imageDesk1x.src}
            deskSrc2x={visual.imageDesk2x.src}
            width={1088}
            height={698}
            alt={title}
            lazyLoad
          />
        </div>
      )}

      <ul className={classes.list}>
        {description.map((element, idx) => {
          return (
            <li key={idx}>
              <Text size={'lg'} center balance className={classes.caption}>
                {element}
              </Text>
            </li>
          )
        })}
      </ul>
    </Block>
  )
}
